export const STATISTICS_SALES_CHANNEL = 'stats/sales_channel'
export const STATISTICS_OUTCOME = 'stats/outcome'
export const STATISTICS_FINANCE = 'stats/finance'
export const STATISTICS_COST_ADVERT = 'stats/cost_advert'
export const STATISTICS_SALES_FUNNEL = 'stats/sales_funnel'
export const STATISTICS_ENDS_STUDENT = 'stats/ends_student'
export const STATISTICS_YEARS_STUDENT = 'stats/students_age'
